// Mapping des codes vers des noms lisibles pour améliorer l'affichage

// Mapping des pays (codes ISO vers noms complets)
export const countryMapping = {
  'FRANCE': 'France',
  'ALLEMAGNE': 'Allemagne', 
  'ITALIE': 'Italie',
  'ESPAGNE': 'Espagne',
  'CHINE': 'Chine',
  'TURQUIE': 'Turquie',
  'MAROC': 'Maroc',
  'TUNISIE': 'Tunisie',
  'EGYPTE': 'Égypte',
  'EMIRATS ARABES UNIS': 'Émirats Arabes Unis',
  'ARABIE SAOUDITE': 'Arabie Saoudite',
  'INDE': 'Inde',
  'BRESIL': 'Brésil',
  'ETATS-UNIS': 'États-Unis',
  'CANADA': 'Canada',
  'JAPON': 'Japon',
  'COREE DU SUD': 'Corée du Sud',
  'ROYAUME-UNI': 'Royaume-Uni',
  'PAYS-BAS': 'Pays-Bas',
  'BELGIQUE': 'Belgique'
}

// Mapping des incoterms vers descriptions
export const incotermMapping = {
  'FOB': 'FOB - Franco à Bord',
  'CIF': 'CIF - Coût, Assurance, Fret',
  'CFR': 'CFR - Coût et Fret',
  'EXW': 'EXW - Ex Works',
  'FCA': 'FCA - Franco Transporteur',
  'CPT': 'CPT - Port Payé Jusqu\'à',
  'CIP': 'CIP - Port Payé, Assurance Comprise',
  'DAP': 'DAP - Rendu au Lieu de Destination',
  'DPU': 'DPU - Rendu au Lieu de Déchargement',
  'DDP': 'DDP - Rendu Droits Acquittés'
}

// Mapping des codes régime APC
export const regimeApcMapping = {
  '40': 'Mise à la consommation directe',
  '42': 'Mise à la consommation avec exonération',
  '01': 'Entrepôt douanier',
  '51': 'Perfectionnement actif',
  '61': 'Transformation sous douane',
  '71': 'Importation temporaire',
  '81': 'Transit',
  '91': 'Dépôt temporaire'
}

// Fonction pour obtenir le nom lisible d'un pays
export const getCountryDisplayName = (countryCode) => {
  if (!countryCode) return 'Non spécifié'
  return countryMapping[countryCode.toUpperCase()] || countryCode
}

// Fonction pour obtenir la description d'un incoterm
export const getIncotermDisplayName = (incoterm) => {
  if (!incoterm) return 'Non spécifié'
  return incotermMapping[incoterm.toUpperCase()] || incoterm
}

// Fonction pour obtenir la description d'un régime APC
export const getRegimeApcDisplayName = (regimeCode) => {
  if (!regimeCode) return 'Non spécifié'
  return regimeApcMapping[regimeCode] || `Régime ${regimeCode}`
}

// Fonction pour formater un numéro de modèle
export const getProductDisplayName = (numeroModele) => {
  if (!numeroModele) return 'Non spécifié'
  
  // Si c'est un code très long, le tronquer avec des points de suspension
  if (numeroModele.length > 30) {
    return `${numeroModele.substring(0, 27)}...`
  }
  
  return numeroModele
}

// Fonction pour formater un NIF importateur
export const getImporterDisplayName = (nifImportateur) => {
  if (!nifImportateur) return 'Non spécifié'
  
  // Formater le NIF pour l'affichage (masquer une partie pour la confidentialité)
  if (nifImportateur.length > 8) {
    return `${nifImportateur.substring(0, 4)}****${nifImportateur.substring(nifImportateur.length - 4)}`
  }
  
  return nifImportateur
}

// Fonction générale pour obtenir un nom d'affichage selon le type
export const getDisplayName = (value, type) => {
  if (!value) return 'Non spécifié'
  
  switch (type) {
    case 'pays_origine':
    case 'country':
      return getCountryDisplayName(value)
    case 'incoterm':
      return getIncotermDisplayName(value)
    case 'code_regime_apc':
    case 'regime':
      return getRegimeApcDisplayName(value)
    case 'numero_modele':
    case 'product':
      return getProductDisplayName(value)
    case 'nif_importateur':
    case 'importer':
      return getImporterDisplayName(value)
    default:
      return value
  }
}

// Fonction pour formater les données pour l'affichage dans les graphiques
export const formatChartData = (data, labelType) => {
  if (!data || !Array.isArray(data)) return []
  
  return data.map(item => ({
    ...item,
    nom: getDisplayName(item.nom, labelType),
    fullName: item.nom, // Garder le nom original pour les tooltips
    displayName: getDisplayName(item.nom, labelType)
  }))
}

// Fonction pour formater les données de table
export const formatTableData = (data) => {
  if (!data || !Array.isArray(data)) return []
  
  return data.map(row => ({
    ...row,
    pays_origine_display: getCountryDisplayName(row.pays_origine),
    incoterm_display: getIncotermDisplayName(row.incoterm),
    code_regime_apc_display: getRegimeApcDisplayName(row.code_regime_apc),
    numero_modele_display: getProductDisplayName(row.numero_modele),
    nif_importateur_display: getImporterDisplayName(row.nif_importateur)
  }))
}
